import { LocationState } from 'history'
import { useHistory as useRouterHistory } from 'react-router'

import useRedirectCleanup from '../features/animation/useRedirectCleanup'

export function useHistory<T = LocationState>() {
  useRedirectCleanup()
  return useRouterHistory<T>()
}
